import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, moduleSequences } from 'app/pwa/app.cerebral';

import { getTagInfoColors, getTagImage } from 'utils/challenge';
import { useText, useConfig, useImage } from 'common/hooks';

import { Container, TextWrapper, Title, Link, Image } from './elements';

type Props = {
  readonly className: string;
};

const deps = {
  selectedTag: state.challenge.log.selectedTag,
  showTagModal: moduleSequences.challenge.tagModal.showTagModalClicked,
};

function CategoryCard({
  className,
  selectedTag,
  showTagModal,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const { staticUrl } = useConfig();

  const image = getTagImage(staticUrl, selectedTag);
  const [imageUrl] = useImage(image.small);

  if (!image) {
    return null;
  }
  const isSDG = image.small.includes('SDG');

  return (
    <Container
      onClick={() => showTagModal({ tag: selectedTag, activityModalKey: null })}
      className={className}
      colors={getTagInfoColors(selectedTag)}
    >
      <TextWrapper needsExtraPadding={isSDG}>
        <Title>{t(`challenge.tags.${selectedTag}.title`)}</Title>
        <Link>{t(`challenge.tags.learn_more`)}</Link>
      </TextWrapper>
      {image.small === imageUrl && (
        <Image src={imageUrl} hasBottomPadding={image.hasBottomPadding} />
      )}
    </Container>
  );
}

export default connect<Props, typeof deps>(deps, CategoryCard);
